// Diagnostic events from the UI (scanner, unhandled errors) for the point's log queue — the
// backend stores them and uploads them to central with the next sync (see backend/lib/clientLog.js).
// Batched; events raised before login are kept until a token appears. Never throws.
import { api } from "../api";

const FLUSH_DELAY_MS = 5000;
const MAX_QUEUE = 200;
const queue = [];
let timer = null;

async function flush() {
  timer = null;
  if (!queue.length) return;
  if (!localStorage.getItem("token")) { schedule(); return; }
  const batch = queue.splice(0, queue.length);
  try {
    await api.postClientLogs(batch, __APP_VERSION__);
  } catch {
    queue.unshift(...batch.slice(-MAX_QUEUE));
    schedule(30000);
  }
}

function schedule(delay = FLUSH_DELAY_MS) {
  if (!timer) timer = setTimeout(flush, delay);
}

function push(level, category, message, details) {
  try {
    queue.push({ level, category, message: String(message), details, at: new Date().toISOString() });
    if (queue.length > MAX_QUEUE) queue.splice(0, queue.length - MAX_QUEUE);
    schedule();
  } catch { /* diagnostics must never break the app */ }
}

export const clientLog = {
  info: (category, message, details) => push("info", category, message, details),
  warn: (category, message, details) => push("warn", category, message, details),
  error: (category, message, details) => push("error", category, message, details),
  // Before the window closes: the 5-second batch would otherwise be lost with the renderer.
  flushNow: (timeoutMs = 1500) => {
    if (timer) { clearTimeout(timer); timer = null; }
    return Promise.race([flush(), new Promise(resolve => setTimeout(resolve, timeoutMs))]).catch(() => {});
  },
};

// Short id in the message keeps events of different scans/patients from merging into one «×N» row
// (dedup is by message text); full ids go to details for search.
export const shortId = (id) => (id ? String(id).slice(0, 8) : "—");
